module.exports = __webpack_public_path__ + "img/work_better2.ca0253a4.png";